import { createSelector as reduxCreateSelector } from '@reduxjs/toolkit';

import { selectBoat } from '@/entities/boat';
import { selectDefault } from '@/features/pick-boat/model/constants/select-default.constant';

export const selectBoatInput = reduxCreateSelector(selectBoat.selectAll, (boats) => ({
	items: boats.map((boat) => ({ value: boat.id, label: boat.mmsi ? `${boat.name} ${boat.mmsi}` : boat.name })),
	length: boats.length,
}));

export const selectBoatForUser = reduxCreateSelector(
	[selectBoatInput, (state, withoutAll: boolean) => withoutAll],
	(boats, withoutAll) => {
		if (withoutAll) {
			return boats;
		}

		return { items: [selectDefault, ...boats.items], length: boats.length };
	},
);
